import React, { ReactElement } from 'react';
import Button from 'react-bootstrap/Button';
import { TitleFormattedMessage } from './titleFormattedMessage';
import PropdocsModal from './modal/PropdocsModal';

interface ConfirmActionModalProps {
  show: boolean;
  onHide: () => void;
  onClick: () => void;
  title: ReactElement;
  message: ReactElement | string;
  action: ReactElement;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const ConfirmActionModal = ({ show, onHide, onClick, title, message, action, size = 'sm' }: ConfirmActionModalProps) => {
  return (
    <PropdocsModal show={show} setShow={onHide} title={title} size={size}>
      <>
        <p style={{ marginBottom: '1.5rem' }}>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
          <Button variant="link" className="text-secondary" onClick={onHide}>
            <TitleFormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
          <Button variant="secondary" onClick={onClick}>
            {action}
          </Button>
        </div>
      </>
    </PropdocsModal>
  );
};

export default ConfirmActionModal;
